// Forråder is delivered as a single self-contained static file (public/app.html).
// Redirect the SPA root to it, preserving query + hash (e.g. #admin).
if (typeof window !== "undefined" && !window.location.pathname.startsWith("/app.html")) {
  window.location.replace("/app.html" + window.location.search + window.location.hash);
}

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const STALE_TIME_MS = 60_000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
